export default __webpack_public_path__ + "static/media/Logout.78bc88a5.png";